/* empty css                   */
import { generateFileThumbnail } from "../../utils/generate-file-thumbnail.js";
import { useEffect, useMemo, useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { startCase } from "lodash-es";
import { MdDeleteForever, MdDescription } from "react-icons/md";
import { FaCirclePlay } from "react-icons/fa6";
import prettyBytes from "pretty-bytes";
// src/modules/Files/components/FileUploadCard/index.tsx
var FileUploadCard = ({ file, isPrimaryImage, onCancel, onClickPreview, onSetPrimaryImage, retryFileUpload }) => {
	const [imageDataUrl, setImageDataUrl] = useState(file.imagePreviewUrl);
	useEffect(() => {
		if (file.type.includes("image") && !file.imagePreviewUrl) generateFileThumbnail(file.file, [70, 70]).then((dataUrl) => setImageDataUrl(dataUrl)).catch((err) => {
			console.warn(`<FileUploadCard /> error generating thumbnail`, err);
		});
	}, [file.file]);
	const primaryImageUrlBtn = useMemo(() => {
		if (!file.type.includes("image")) return null;
		if (isPrimaryImage) return /* @__PURE__ */ jsx("span", {
			className: "text-color-main text-center text-sm",
			children: "Primary Image"
		});
		if (file.status === "uploaded" || file.status === "ready-to-upload") {
			if (onSetPrimaryImage && file.accessUrl) return /* @__PURE__ */ jsx(Button, {
				onClick: () => onSetPrimaryImage(file.accessUrl, file),
				size: "xs",
				subtle: true,
				children: "Set as Primary"
			});
		}
	}, [
		file,
		isPrimaryImage,
		onSetPrimaryImage
	]);
	const fileSize = prettyBytes(+file.size);
	const iconName = useMemo(() => {
		if (file.type.includes("video")) return FaCirclePlay;
		if (file.type.includes("text")) return MdDescription;
		return IoIosInformationCircleOutline;
	}, []);
	return /* @__PURE__ */ jsx("div", {
		className: "file-upload-card bg-surface border-border h-24 w-72 rounded border",
		children: /* @__PURE__ */ jsxs("div", {
			className: "p-xs gap-x-xs inline-flex h-full w-full",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "relative",
				children: [/* @__PURE__ */ jsx("div", {
					className: "h-full w-24 overflow-hidden",
					children: imageDataUrl ? /* @__PURE__ */ jsx("div", {
						onClick: () => onClickPreview && onClickPreview(file),
						children: /* @__PURE__ */ jsx("img", {
							className: "rounded",
							src: imageDataUrl
						})
					}) : /* @__PURE__ */ jsx("div", {
						className: "bg-surface-strong p-xs flex h-full w-full flex-col items-center justify-center rounded-md",
						children: /* @__PURE__ */ jsx(Icon, {
							color: "neutral",
							Icon: iconName,
							size: "xl"
						})
					})
				}), /* @__PURE__ */ jsxs("div", {
					className: "bg-surface pr-xxs absolute bottom-0 flex max-w-max flex-col items-start rounded-t-sm pt-0.5",
					children: [file.status === "uploading" && /* @__PURE__ */ jsx("progress", {
						className: "w-full rounded",
						value: (file.uploadProgress || 1) / 100
					}), file.status.includes("error") ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("span", {
						className: "text-color-critical text-xs tracking-wide",
						children: [startCase(file.status), " "]
					}), retryFileUpload && /* @__PURE__ */ jsx(Button, {
						onClick: () => retryFileUpload(file.id),
						size: "sm",
						subtle: true,
						children: "Retry"
					})] }) : /* @__PURE__ */ jsx("span", {
						className: "text-color-positive text-center text-xs tracking-wide",
						children: startCase(file.status)
					})]
				})]
			}), /* @__PURE__ */ jsxs("div", {
				className: "relative flex w-full min-w-0 flex-col justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "mt-xxs text-sm",
					children: [/* @__PURE__ */ jsx("div", {
						className: classnames({ "text-color-critical": file.type === "error" }, "line-clamp-2"),
						children: file?.name
					}), /* @__PURE__ */ jsx("div", {
						className: "text-color-subtle text-xs font-medium",
						children: fileSize
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "gap-x-xxs inline-flex items-end justify-between",
					children: [/* @__PURE__ */ jsx("span", { children: primaryImageUrlBtn }), !!onCancel && /* @__PURE__ */ jsx(Button, {
						className: "group",
						onClick: () => onCancel(file),
						size: "xs",
						subtle: true,
						variant: "critical",
						children: /* @__PURE__ */ jsx(Icon, {
							className: "group-hover:text-color-critical text-color-neutral transition",
							Icon: MdDeleteForever,
							size: "sm"
						})
					})]
				})]
			})]
		})
	});
};
export { FileUploadCard };

//# sourceMappingURL=index.js.map